import React, { useEffect, useRef, useState } from "react";
import { NotebookPen, Lock } from "lucide-react";
import api from "../lib/api";

export const markWatched = (id) => api.post(`/sermons/${id}/watched`).catch(() => {});

export const SermonNotes = ({ sermonId, compact = false }) => {
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("");
  const timer = useRef();
  const loaded = useRef(false);

  useEffect(() => {
    loaded.current = false;
    api.get(`/sermons/${sermonId}/note`).then(({ data }) => { setBody(data.body || ""); loaded.current = true; }).catch(() => {});
    return () => clearTimeout(timer.current);
  }, [sermonId]);

  const onChange = (v) => {
    setBody(v);
    if (!loaded.current) return;
    setStatus("Saving…");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.put(`/sermons/${sermonId}/note`, { body: v }).then(() => setStatus("Saved")).catch(() => setStatus("Couldn't save — try again"));
    }, 700);
  };

  return (
    <div data-testid={`sermon-notes-${sermonId}`} className="mt-3 rounded-xl border p-3" style={{ borderColor: "var(--sj-border)", background: "#FBFAF7" }}>
      <div className="flex items-center justify-between text-xs font-semibold" style={{ color: "var(--sj-primary)" }}>
        <span className="flex items-center gap-1.5"><NotebookPen className="h-3.5 w-3.5" /> My notes</span>
        <span className="flex items-center gap-1 font-normal" style={{ color: "var(--sj-text-3)" }} data-testid={`sermon-notes-status-${sermonId}`}>
          {status || <><Lock className="h-3 w-3" /> Only you can see these</>}
        </span>
      </div>
      <textarea data-testid={`sermon-notes-input-${sermonId}`} value={body} onChange={(e) => onChange(e.target.value)} rows={compact ? 3 : 5}
        placeholder="Jot down scriptures, key points or what God is saying to you…"
        className="mt-2 w-full bg-white border border-[#EBE9E4] rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#0B5E4E]/20 focus:border-[#0B5E4E] resize-y" />
    </div>
  );
};
